module.exports = __webpack_public_path__ + "static/media/play-store.f0df380d.svg";